import type { CSSProperties, FC } from "react";

interface CardSeparatorProps {
  style?: CSSProperties;
}

export const CardSeparator: FC<CardSeparatorProps> = ({ style }) => {
  return <span data-testid="card-separator" style={{ borderBottom: "1px solid var(--secondary-pale)", ...style }} />;
};
